import { render } from "./ControlDataPopup.vue?vue&type=template&id=2877755c&scoped=true&ts=true"
import script from "./ControlDataPopup.vue?vue&type=script&lang=ts"
export * from "./ControlDataPopup.vue?vue&type=script&lang=ts"

import "./ControlDataPopup.vue?vue&type=style&index=0&id=2877755c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/rontend-vue_version_release-euau/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2877755c"]])

export default __exports__